import api, { withLoading } from '@/api/api';

/**
 * @typedef {object} ParametroWorkflow
 * @property {boolean} definir_revisores - Indica se é possível definir revisores manualmente
 * @property {number} id - Identificador único do parâmetro
 * @property {string} nome - Nome da etapa do workflow
 * @property {number} ordem - Ordem de exibição (pode ser negativo)
 * @property {number} quantidade_revisores_aprovacao - Quantidade mínima de revisores para aprovação
 * @property {Array<{id: number, nome: string}> | null} revisores - Lista de revisores vinculados
 * @property {Array<number> | null} revisores_tipo_id - IDs dos tipos de revisor
 * @property {number} sla - SLA em dias úteis para a etapa
 */

const resource = (empresaId) => `v1/ativacaoped/${empresaId}/workflow-parametrizacao`;
const LOADING_KEY = 'ativacaoped-workflow';

export default {
  /**
   * Get workflow parametrization data.
   * GET /v1/ativacaoped/:empresaId/workflow-parametrizacao
   * @param {number} empresaId
   * @param {object} [params={}] - optional query parameters
   * @returns {Promise<ParametroWorkflow[]>}
   */
  getWorkflowParametrizacao(empresaId, params = {}) {
    const query = Object.keys(params).length
      ? `?${new URLSearchParams(params).toString()}`
      : "";
    return withLoading(LOADING_KEY, () =>
      api.get(`${resource(empresaId)}${query}`).then(res => res.data.data)
    );
  },

  /**
   * Create a new workflow parametrization.
   * POST /v1/ativacaoped/:empresaId/workflow-parametrizacao
   * @param {number} empresaId
   * @param {ParametroWorkflow} data - payload to create
   * @returns {Promise<ParametroWorkflow>}
   */
  createWorkflowParametrizacao(empresaId, data) {
    return withLoading(LOADING_KEY, () =>
      api.post(`${resource(empresaId)}`, data).then(res => res.data.data)
    );
  },

  /**
   * Update an existing workflow parametrization.
   * POST /v1/ativacaoped/:empresaId/workflow-parametrizacao
   * @param {number} empresaId
   * @param {ParametroWorkflow} data - payload to update
   * @returns {Promise<ParametroWorkflow>}
   */
  updateWorkflowParametrizacao(empresaId, data) {
    return withLoading(LOADING_KEY, () =>
      api.post(`${resource(empresaId)}`, data).then(res => res.data.data)
    );
  }
};
